import React, { useEffect } from 'react';
import {
    EmojiEmotions,
    EmojiEvents,
    Flag,
    MilitaryTech,
    Apartment,
    Star,
    SupportAgent,
    Flight,
    EventAvailable,
    CurrencyExchange,
    Diversity3,
    Groups2,
    WorkspacePremium,
    School
} from '@mui/icons-material';
import './AboutUs.css';
import NewNavBar from '../../components/NewNavBar/NewNavBar';
import HeaderComponent from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import gallery1 from '../../assets/images/group1.jpg'
import gallery2 from '../../assets/images/group 2.jpg'
import gallery3 from '../../assets/images/group 3.jpg'
import gallery4 from '../../assets/images/group 4.jpeg'
import gallery5 from '../../assets/images/group 5.jpeg'
import gallery6 from '../../assets/images/group 6.jpeg'
import owner from '../../assets/images/owner.jpg'

const AboutUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const stats = [
        { icon: <EmojiEmotions fontSize="large" />, value: '8,74,799', label: 'Happy Guests' },
        { icon: <EmojiEvents fontSize="large" />, value: '67,844', label: 'Tours Completed' },
        { icon: <Flag fontSize="large" />, value: '2500+', label: 'Tour Destinations' },
        { icon: <MilitaryTech fontSize="large" />, value: '325+', label: 'Tour Experts' },
        { icon: <Apartment fontSize="large" />, value: '150+', label: 'Branches & Sales Partners' }
    ];

    const features = [
        { icon: <School />, title: 'Product Research', text: 'Itineraries built with continuous research and improvement checks.' },
        { icon: <Groups2 />, title: 'Tour Managers', text: '350+ Tour Managers celebrating life with thousands of travellers everyday.' },
        { icon: <Star />, title: 'All-inclusive', text: 'All-inclusive tours with no hidden costs.' },
        { icon: <SupportAgent />, title: 'Main Hoon Na!', text: 'Your tour manager is with you throughout the tour.' },
        { icon: <Flight />, title: 'Air & VISA', text: 'Dedicated team takes care of all your Air & VISA needs.' },
        { icon: <EventAvailable />, title: '3000+ Departures', text: 'Multiple tours and departures so you pick the best date.' },
        { icon: <WorkspacePremium />, title: '24x7 Connect', text: 'Guest Relations team is available 24x7 all throughout.' },
        { icon: <CurrencyExchange />, title: 'FOREX', text: 'Get the best foreign currency rates with our Forex support.' }
    ];

    const team = [
        { name: 'Mangesh', role: 'Founder & CEO', img: owner },
        { name: 'Mahendra', role: 'Founder & Chief Product Officer', img: owner },
        { name: 'Dinesh', role: 'Marketing Manager', img: owner },
        // { name: 'Neil Patil', role: 'Founder, CTO and COO', img: 'https://via.placeholder.com/420x520?text=Neil+Patil' },
        // { name: 'Abhijit Gore', role: 'Director', img: 'https://via.placeholder.com/420x520?text=Abhijit+Gore' }
    ];

    const galleryImages = [
        gallery1,
        gallery2,
        gallery3,
        gallery4,
        gallery5,
        gallery6,
    ];

    return (
        <div className="about-container">
            <div><HeaderComponent /></div>
            <div><NewNavBar /></div>

            {/* Header */}
            <div className="about-header">
                <div className="header-content">
                    <div className="header-icon">
                        <Star style={{ fontSize: 48 }} />
                    </div>
                    <div className="header-text">
                        <h1>About Us</h1>
                        <p className="header-description">
                            We create joyful travel experiences with research-driven itineraries, reliable service, and all-inclusive value. Get to know the people, processes, and passion behind our journeys.
                        </p>
                    </div>
                </div>
            </div>

            <div className="about-content">
                {/* Experience / Stats */}
                <section className="experience-section">
                    <h2 className="section-heading">
                        <span className="highlight">10+ years</span><spam className='normal-text'>of experience</spam>
                    </h2>
                    <div className="stats-grid">
                        {stats.map((s, i) => (
                            <div key={i} className="stat-card">
                                <div className="stat-icon">{s.icon}</div>
                                <div className="stat-value">{s.value}</div>
                                <div className="stat-label">{s.label}</div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Leadership */}
                <section className="leadership-section">
                    <h2 className="section-heading">Our Leadership Team</h2>
                    <div className="team-grid">
                        {team.map((member, idx) => (
                            <div className="team-card" key={idx}>
                                <div className="team-image-wrapper">
                                    <img src={member.img} alt={member.name} className="team-image" />
                                </div>
                                <div className="team-info">
                                    <div className="team-name">{member.name}</div>
                                    <div className="team-role">{member.role}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Why Veena World - Everything under one roof */}
                <section className="features-section">
                    <p className="eyebrow">Why Ghoomo World?</p>
                    <h2 className="section-heading">Everything under One Roof</h2>
                    <div className="features-grid">
                        {features.map((f, i) => (
                            <div className="feature-card" key={i}>
                                <div className="feature-icon">{f.icon}</div>
                                <div className="feature-title">{f.title}</div>
                                <div className="feature-text">{f.text}</div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Life at Veena World family */}
                <section className="gallery-section">
                    <p className="eyebrow">Life at Ghoomo World</p>
                    <h2 className="section-heading">The Ghoomo World family!</h2>
                    <div className="gallery-grid">
                        {galleryImages.map((src, i) => (
                            <div className="gallery-item" key={i}>
                                <img src={src} alt={`gallery-${i + 1}`} />
                            </div>
                        ))}
                    </div>
                </section>

                {/* Join our family CTA */}
                <section className="cta-section">
                    <div className="cta-inner">
                        <div className="cta-left">
                            <h3>
                                Come,
                                <br />
                                let's grow together!
                            </h3>
                        </div>
                        <div className="cta-right">
                            <h4>We are on a mission</h4>
                            <ul>
                                <li>To create a community of happy travelers with a personal touch.</li>
                                <li>To make the world affordable through continuous innovation.</li>
                                <li>To inspire our teams and associates for higher achievements.</li>
                                <li>To build India's most admired travel company with a global family.</li>
                            </ul>
                            {/* <button className="primary-btn">Join our Family</button> */}
                        </div>
                    </div>
                </section>
            </div>

            <div><Footer /></div>
        </div>
    );
};

export default AboutUs;


